<script lang="ts">
    import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons'
    import Fa from 'svelte-fa'
    import { slide } from 'svelte/transition'
    export let expand = false
    export let label: string = expand ? 'Exibir menos' : 'Exibir mais'
    let className = ''
    export { className as class }

    function toggle() {
        expand = !expand
        if (label == 'Exibir mais' && expand) label = 'Exibir menos'
        if (label == 'Exibir menos' && !expand) label = 'Exibir mais'
        console.log(expand)
        return label
    }
</script>

<div class="z-expand {className}" on:click={toggle}>
    <div class="-label">{label}</div>
    <Fa icon={expand ? faArrowUp : faArrowDown} />
</div>

{#if expand}
    <div transition:slide={{ duration: 250 }}>
        <slot />
    </div>
{/if}

<style>
    .z-expand {
        display: flex;
        width: 100%;
        align-items: center;
        font-style: italic;
        cursor: pointer;
    }
    :global(.z-expand > svg) {
        margin-left: 4px;
        padding: 1px;
    }
</style>
